import { useAuthUser } from './useAuth';
import { useProductCatalog } from './useProductCatalog';
import { useCarts } from './useCarts';
import { useFavorites } from './useFavorites';
import { useFavoriteGroups } from './useFavoriteGroups';
import { useCompareItems } from './useCompareItems';
import { useDashboard } from './useDashboard';
import {
  useTerritories,
  useApplications,
  useIndications,
  useCategories,
  useMarketingClaims,
  usePartners,
} from './useMasterData';

/**
 * Eagerly subscribes to every user-facing query right after login so the
 * React Query persister captures a snapshot of the full app state on first
 * online use. Without this, a page the user never opened online (typically
 * the Wizard or filter-heavy Product List) has no cached data to fall back
 * on when the app is launched offline (VIVATISPDB-306).
 *
 * Each hook is called unconditionally — they gate themselves via the
 * `enabled` flag and share their cache via the queryKey with the page-level
 * consumer, so mounting them here costs only one fetch per resource.
 */
export function useOfflinePrefetch(isLoggedIn: boolean): void {
  useAuthUser(isLoggedIn);
  useProductCatalog(isLoggedIn);

  useCarts(isLoggedIn);
  useFavorites(isLoggedIn);
  useFavoriteGroups(isLoggedIn);
  useCompareItems(isLoggedIn);
  useDashboard(isLoggedIn);

  useTerritories(isLoggedIn);
  useApplications(isLoggedIn);
  useIndications(isLoggedIn);
  useCategories(isLoggedIn);
  useMarketingClaims(isLoggedIn);
  usePartners(isLoggedIn);
}
